import angular from 'angular';

angular
  .module('cxInvoicing')
  .controller('InvoiceAuditDialogCtrl', [
    '$element',
    '$window',
    'reminderHttpSvc',
    'close',
    'invoice',
    '$http',
    'Blob',
    'FileSaver',
    'appUrls',
    'flySvc',
    'dataCache',
    invoiceAuditDialogCtrl,
  ]);

function invoiceAuditDialogCtrl(
  $element,
  $window,
  reminderHttpSvc,
  close,
  invoice,
  $http,
  Blob,
  FileSaver,
  appUrls,
  flySvc,
  dataCache,
) {
  var vm = this;
  vm.invoice = invoice;
  vm.data = [];
  const helpArticles = [
    { auditAction: 33, articleNumber: '6207683197852' },
    { auditAction: 52, articleNumber: '18587480798108', anchor: '#h_01JMHED7VJD7FXEYQ6G6AVHK4S' },
  ];

  var getAuditLines = function() {
    $http
      .get(appUrls.api + '/api/invoice/auditlines/' + invoice.id)
      .then(function(response) {
        var result = response.data;
        if (result && result.length > 0) {
          vm.data = result.reduce((a, line) => {
            const key = line.oldInvoiceId || '';
            let group = a.find(x => x.key === key);
            if (!group) {
              group = {
                key,
                lines: [],
                isMain: !line.oldInvoiceId,
                order: !line.oldInvoiceId ? 0 : a.length + 1,
              };
              a.push(group);
            }
            group.lines.push({
              ...line,
              article: helpArticles.some(article => article.auditAction === line.auditAction)
                ? helpArticles.find(article => article.auditAction === line.auditAction)
                : undefined,
            });
            return a;
          }, []);
        }
      })
      .catch(function(error) {});
  };
  getAuditLines();

  vm.cancel = function() {
    close(null, 500);
  };
}
